import { EstimationsChartMonthlyData, EstimationsChartWeeklyData, EstimationsPieChartData } from './estimations-pie-chart-data.model';
import { RequisitionsChartMonthlyData, RequisitionsChartWeeklyData, RequisitionsPieChartData } from './requisitions-pie-chart-data.model';

export interface ProjectMetrics {
  Budget: {
    baselineBudget: number,
    controlBudget: number
  },
  ExecutionCost: {
    ProjectExecutionCost: number,
    remainingBudget: number,
    progress: number
  },
  RequisitionsData: RequisitionsPieChartData,
  MonthlyRequisition: RequisitionsChartMonthlyData[],
  WeeklyRequisition: RequisitionsChartWeeklyData[],
  WorkPerformedValue: EstimationsPieChartData,
  MonthlyWorkPerformedValues: EstimationsChartMonthlyData[],
  WeeklyWorkPerformedValues: EstimationsChartWeeklyData[],
}

export interface ProjectsList {
  projectId: number;
  projectKey: string;
  projectName: string;
  projectCity: string;
  projectCompanyId: number;
  projectCompany: string;
  projectDescription: string;
}

export interface ProjectTemplate {
  id: number;
  name: string;
  description: string;
}

export interface ProjectResponse {
  limit: number;
  page: number;
  total: number;
  rows?: ProjectsList[];
}

export interface ProjectError {
  'has-error': boolean;
  error?: {
    title: string | null,
    message: string | null,
    'type_id': number,
    type: string | null,
    'mode_id': number,
    mode: string | null,
  };
}

export interface ProjectData {
  status: string;
  error: ProjectError;
  response: ProjectResponse | ProjectMetrics;
}

export interface Resource {
  id: number;
  componentId: number;
  resourceId: number;
  quantity: number;
  name: string;
  code: string;
  description: string;
  unit: string;
  type: string;
}

export interface ProjectStructure {
  id: number;
  name: string;
  code: string;
  description: string;
  order: number;
  parentId: string;
  type: string;
  isBatchProduction: boolean;
  SubComponents?: ProjectStructure[] | null;
  ComponentResource?: Resource[] | null;
  [key: string]: any
}

// export interface NzTreeNodeOptions {
//   title: string;
//   key: string;
//   icon: string;
//   children: NzTreeNodeOptions[];
//   isLeaf: boolean;
//   checked: boolean;
//   selected: boolean;
//   expanded: boolean;
//   selectable: boolean;
//   disabled: boolean;
//   disabledCheckBox: boolean;
//   [key: string]: any;
// }

export interface ProjectStructureResponse {
  status: string;
  error: ProjectError;
  response: {
    projectId: number;
    code: string;
    description: string;
    name: string;
    ProjectComponents: ProjectStructure[];
  };
}

export enum Context {
  WBSBatchProduction = 'WBSBatchProduction',
  WBSComponent = 'WBSComponent',
  WBSProductionUnit = 'WBSProductionUnit',
  WBSResource = 'WBSResource',
  RequisitionItem = "RequisitionItem"
}

export enum Type {
  Activity = 'Activity',
  Indirect = 'Indirect',
  Machinery = 'Machinery',
  Material = 'Material',
  Package = 'Package',
  Piecework = 'Piecework',
  SubContract = 'SubContract',
  ProductionUnitUnit = 'ProductionUnitUnit',
  Project = 'Project'
}

export interface WBSResourceNode {
  unit: string;
  unitCost: number;
  budgetedQuantity: number;
  consumedQuantity: number;
  previouslyConsumedQuantity: number;
  totalConsumedQuantity: number;
  remainingQuantity: number;
  currentInputQuantity: number;
  currentInputPercentage: number;
  quantity: number;
  totalRemainingQuantity: number;
  currentConsumedQuantity: number;
  currentRemainingQuantity: number;
}

export interface ResourcesOfEntity {
  id: number;
  context: Context;
  key: string;
  parentKey: string;
  name: string;
  code: string;
  description: string;
  type: Type;
  order: number;
  Nodes?: ResourcesOfEntity[];
  WBSResourceNode?: WBSResourceNode;
  componentResourceId: number;
  productionUnitId: number;
  [key: string]: any;
}

export interface ResourcesOfEntityResponse {
  status: string;
  error: ProjectError;
  response: ResourcesOfEntity;
}

export interface ProjectAdapter {
  adapt(dtoBackend: any): ProjectTemplate;
}

export class ProjectBackendAdapter implements ProjectAdapter{
  adapt(dtoBackend: any): ProjectTemplate{
    return {
      id: dtoBackend.projectId,
      name: dtoBackend.projectName,
      description: dtoBackend.projectDescription
    }
  }
}
